import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject, formatYearAndVersionType, keyify} from "../common";
import {renderOperationalMonthValue} from "./common";
import * as common from "../styles/common.module.scss";

const AMOUNT_KEYS = [
    "amountMonth0",
    "amountMonth1",
    "amountMonth2",
    "amountMonth3",
    "amountMonth4",
    "amountMonth5",
    "amountMonth6",
    "amountMonth7",
    "amountMonth8",
    "amountMonth9",
    "amountMonth10",
    "amountMonth11"
];

const PERCENT_KEYS = [
    "percentMonth0",
    "percentMonth1",
    "percentMonth2",
    "percentMonth3",
    "percentMonth4",
    "percentMonth5",
    "percentMonth6",
    "percentMonth7",
    "percentMonth8",
    "percentMonth9",
    "percentMonth10",
    "percentMonth11"
];

export interface RenderUpdateOperationalDriverAssumptionsProps extends RendererProps {
    operationalMetricTypes: {id: string, name: string}[]
}

export function RenderUpdateOperationalDriverAssumptions(props: RenderUpdateOperationalDriverAssumptionsProps): ReactElement {
    const items = props.variables["items"];
    if(!Array.isArray(items)) {
        return <></>;
    }

    if(items.length === 0) {
        return <div>No change</div>;
    }

    const itemRenders: ReactElement[] = [];
    for(const item of items) {
        if(typeof item !== "object" || item === null) {
            continue;
        }

        const name = item["name"];
        const year = item["year"];
        const versionType = item["versionType"];
        const sourceMetricId = item["sourceMetricId"];

        const itemKey = `${keyify(name)}-${keyify(sourceMetricId)}`;
        let sourceMetric: typeof props.operationalMetricTypes[0] | undefined = undefined;
        if(typeof sourceMetricId === "string") {
            sourceMetric = props.operationalMetricTypes.find(m => m.id === sourceMetricId);
        }

        const vals: ReactElement[] = [];
        for(let i = 0; i < 12; i++) {
            const amountKey = AMOUNT_KEYS[i];
            const percentKey = PERCENT_KEYS[i];

            if(!amountKey || !percentKey) {
                continue;
            }

            const amount = item[amountKey];
            const percent = item[percentKey];

            if(amount === null || amount === undefined || percent === null || percent === undefined) {
                continue;
            }

            vals.push(<li key={`${itemKey}-${i}`}>
                {renderOperationalMonthValue(i + 1, sourceMetric, percent, amount)}
            </li>);
        }

        itemRenders.push(
            <div key={itemKey} className={common.arrayItem}>
                <div className={common.textHeader}>{formatYearAndVersionType(year, versionType)}</div>
                <div>Name: {ensureNotObject(name)}</div>
                <ul>
                    {vals}
                </ul>
            </div>
        );
    }

    return <div>
        {itemRenders}
    </div>;
}